import type { MonitoringSite } from '../../../../../types/apiModels'
import { apiClient } from '../../../client'
import endpoints from '../../../endpoints'
import { unwrapSingle } from '../../../normalize'

export default async function add({ site }: { site: MonitoringSite }): Promise<MonitoringSite> {
  const response = await apiClient.post(endpoints.v2.monitoring.sites, site)
  return unwrapSingle<MonitoringSite>(response)
}
